import SimpleDate from "app/common/classes/simple-date"

export enum SubsidiesActSection {
  RestFood = 'rest_food',
}
export type DocumentActSubsidiesType = {
  school: string,
  month: string,
  year: number,
  school_sign_label: string,
  director: string,
  foodSupplierAddressLabel: string,
  foodSupplierAddressValue: string,
  foodSupplierNameLabel: string,
  foodSupplierNameValue: string,
  foodSupplierContactPersonLabel: string,
  foodSupplierContactPersonValue: null | string,
  foodSupplierSignLabel: string
}

export type CompensationActType = {
  compensation: string
  students: number,
  totalCompensation: string,
}


export type AgeGroupTitle = string

export type AgeGroupActType = {
  title: AgeGroupTitle
  total: string,
  compensationPerStudent: Array<CompensationActType>,
}


export type AllowanceName = string

export type KlassesActType = {
  title: AllowanceName
  total: string,
  compensationPerStudent: Array<CompensationActType>,
}
export type DayCaresActType = {
  title: AllowanceName
  ageGroups: Array<AgeGroupActType>
}

export type RowActData = {
  klasses: Array<KlassesActType>
  dayCares: Array<DayCaresActType>
}

export type SubsidyActSummaryType = {
  totalSum: string,
  totalStudents: number,
  totalSubsidyCount: number,
  totalKlassesSum: string,
  totalKlassesStudents: number,
  totalDayCaresSum: string,
  totalDayCaresStudents: number
}

export type ReportSubsidiesActData = {
  section: SubsidiesActSection.RestFood,
  document: DocumentActSubsidiesType,
  dateFrom: SimpleDate
  dateTo: SimpleDate
  rows: RowActData
  summary: SubsidyActSummaryType
}
